export default {
    series: [{
        type: 'gauge',
        startAngle: -270,
        endAngle: 90,
        min: 0,
        max: 240,
        clockwise: false,
        progress: {
            show: true,
            roundCap: true,
            width: 14,
            itemStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#9CD4FF' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#036DB8' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }
            }
        },
        axisLine: {
            lineStyle: {
                width: 14,
                color: [[1, '#dddddd']]
            }
        },
        pointer: {
            show: false
        },
        axisTick: {
            show: false
        },
        splitLine: {
            show: false
        },
        axisLabel: {
            show: false
        },
        detail: {
            show: false
        },
        data: []
    }]
};
